module.exports = __webpack_public_path__ + "img/21.c92c5830.png";